export default __webpack_public_path__ + "static/media/Entrepreneurship.630df8bc.png";